<template>
  <div>
    <div class="fix-wrapper">
      <breadcrumb
        :crumbs="[$t('menu.adapters'), $t('action.manualImport')]"
      ></breadcrumb>
      <div class="container">
        <div
          class="pd20"
          :class="
            importObj.adapter === 'amazon' &&
            (dateFromChangeDiffData != null || dateEndChangeDiffData != null)
              ? 'adapterImport'
              : ''
          "
        >
          <el-form ref="importObjFrom" :model="importObj">
            <div class="center" style="width: 440px; margin: 0 auto">
              <el-form-item
                :prop="'dateFrom'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('text.startTimeAt')]),
                    trigger: 'blur',
                  },
                ]"
                required
              >
                <el-date-picker
                  size="small"
                  v-model="importObj.dateFrom"
                  type="datetime"
                  style="width: 100%"
                  :placeholder="$t('text.startTimeAt')"
                  :picker-options="disPickerTodayAfterDate"
                  @change="dateFromChange"
                />
              </el-form-item>
              <span
                class="font10 float-left mgb10 mgl30"
                v-if="
                  importObj.adapter === 'amazon' &&
                  dateFromChangeDiffData != null
                "
              >
                {{ dateFromChangeDiffData }} PDT
              </span>

              <el-form-item
                :prop="'dateEnd'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('text.endTimeAt')]),
                    trigger: 'blur',
                  },
                ]"
                required
              >
                <el-date-picker
                  size="small"
                  v-model="importObj.dateEnd"
                  type="datetime"
                  style="width: 100%"
                  :placeholder="$t('text.endTimeAt')"
                  :picker-options="disPickerTodayAfterDate"
                  @change="dateEndChange"
                />
              </el-form-item>
              <div
                class="font10 float-left mgb10 mgl30"
                v-if="
                  importObj.adapter === 'amazon' &&
                  dateEndChangeDiffData != null
                "
              >
                {{ dateEndChangeDiffData }} PDT
              </div>
              <div class="orange mgb15 font10 clearfix">
                {{ $t("prompt.adapterImportExplain") }}
              </div>
              <div
                class="orange mgb15 font8 clearfix"
                v-if="importObj.adapter === 'amazon'"
              >
                美国站点：亚马逊后台显示时间 + 15小时，即上方拉单时间
              </div>

              <el-form-item
                :prop="'adapter'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.select', [$t('menu.platforms')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-radio-group
                  v-model="importObj.adapter"
                  size="small"
                  @change="selectAdapter(importObj.adapter)"
                >
                  <el-radio
                    v-for="adapter of adapters"
                    :key="adapter.label"
                    :label="adapter.label"
                    class="float-left"
                    >{{ $t("adapters." + adapter.label) }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                v-if="manageStores.length != 0"
                :prop="'storeIds'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.select', [$t('menu.shops')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-checkbox-group v-model="importObj.storeIds" class="mb15">
                  <el-checkbox
                    v-for="store of manageStores"
                    :key="store.id"
                    :label="store.id"
                    class="float-left"
                    >{{ store.name }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="form-footer">
          <el-button
            v-if="amazonSubmitDF == true"
            slot="append"
            type="primary"
            disabled
            >{{ currentLastTime }}s</el-button
          >
          <el-button
            v-if="amazonSubmitDF == false"
            type="primary"
            size="medium"
            plain
            :loading="saveSubmitDing"
            @click="saveSubmit"
            >{{ $t("action.adapterImport") }}</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { page } from "@/utils/mixins.js";
import Util from "@/utils";
import AliexpressStore from "@/api/adapterAliexpressStore";
import EbayStore from "@/api/adapterEbayStore";
import AmazonStore from "@/api/adapterAmazonStore";
import ShopifyStore from "@/api/adapterShopifyStore";
import TaobaoStore from "@/api/adapterTaobaoStore";

export default {
  mixins: [page],
  components: {},
  data() {
    return {
      disPickerTodayAfterDate: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      // 平台导入
      adapters: [],
      importObj: {
        dateFrom: null,
        dateEnd: null,
        adapter: null,
        storeIds: [],
      },
      manageStores: [],
      saveSubmitDing: false,

      dateFromChangeDiffData: null,
      dateEndChangeDiffData: null,
      //
      currentLastTime: 180,
      amazonSubmitDF: false,
    };
  },
  mounted() {},
  created() {
    const self = this;
    self.adapters = [];
    // if (self.Permit.extendModels().includes("adapterC")) {
    //   self.getTaobaoStore();
    // }
    if (self.Permit.extendModels().includes("adapterI")) {
      self.getInternational();
    }
  },
  methods: {
    dateFromChange() {
      if (this.importObj.dateFrom != null) {
        let dateFrom = new Date(this.importObj.dateFrom);
        this.dateFromChangeDiffData = Util.formatDateTimeYMDHMS(
          Util.dateAddMinute(dateFrom, -(15 * 60))
        );
      } else {
        this.dateFromChangeDiffData = null;
      }
    },
    dateEndChange() {
      if (this.importObj.dateEnd != null) {
        let dateEnd = new Date(this.importObj.dateEnd);
        this.dateEndChangeDiffData = Util.formatDateTimeYMDHMS(
          Util.dateAddMinute(dateEnd, -(15 * 60))
        );
      } else {
        this.dateEndChangeDiffData = null;
      }
    },

    getTaobaoStore() {
      const self = this;
      TaobaoStore.findOwnerStore().then(function (res) {
        if (res.data.length !== 0) {
          self.adapters.push({
            label: "taobao",
            items: res.data,
          });
        }
      });
    },
    getInternational() {
      const self = this;
      axios
        .all([
          // AliexpressStore.findOwnerStore(),
          EbayStore.findOwnerStore(),
          AmazonStore.findOwnerStore(),
          ShopifyStore.findOwnerStore(),
        ])
        .then(
          axios.spread(function (
            // aliexpressStores,
            ebayStores,
            amazonStores,
            shopifyStores
          ) {
            // if (aliexpressStores.data.length !== 0) {
            //   self.adapters.push({
            //     label: "aliexpress",
            //     items: aliexpressStores.data,
            //   });
            // }
            if (ebayStores.data.length !== 0) {
              self.adapters.push({ label: "ebay", items: ebayStores.data });
            }
            if (amazonStores.data.length !== 0) {
              self.adapters.push({ label: "amazon", items: amazonStores.data });
            }
            if (shopifyStores.data.length !== 0) {
              self.adapters.push({
                label: "shopify",
                items: shopifyStores.data,
              });
            }
          })
        );
    },

    //====
    selectAdapter(adapter) {
      this.manageStores = [];
      this.importObj.storeIds = [];
      this.manageStores = this.adapters.find((a) => a.label === adapter).items;
      this.amazonSubmitDF = false;
    },
    saveSubmit() {
      let self = this;
      self.$refs.importObjFrom.validate((valid) => {
        if (valid) {
          let dateFrom = new Date(this.importObj.dateFrom);
          let dateEnd = new Date(this.importObj.dateEnd);
          const obj = {
            ids: self.importObj.storeIds,
            dateFrom: Util.formatDateTimeYMDHMS(
              Util.dateAddMinute(dateFrom, -5)
            ),
            dateEnd: Util.formatDateTimeYMDHMS(Util.dateAddMinute(dateEnd, -5)),
          };
          if (obj.ids.length === 0) {
            self.$message({
              message: self.$t("prompt.unSelectPlatformStore"),
              type: "warning",
            });
            return;
          }
          const difTime =
            new Date(obj.dateEnd.replace(/-/g, "/")) -
            new Date(obj.dateFrom.replace(/-/g, "/"));
          if (difTime > 1000 * 60 * 60 * 24) {
            self.$message({
              message: self.$t("prompt.hourBeyond24H"),
              type: "warning",
            });
            return;
          }
          if (self.importObj.adapter === "aliexpress") {
            self.importAliexpress(obj);
          }
          if (self.importObj.adapter === "ebay") {
            self.importEbay(obj);
          }
          if (self.importObj.adapter === "amazon") {
            self.importAmazon(obj);
          }
          if (self.importObj.adapter === "shopify") {
            self.importShopify(obj);
          }
          if (self.importObj.adapter === "taobao") {
            self.importTaobao(obj);
          }
        } else {
          return false;
        }
      });
    },
    importAliexpress(obj) {
      const self = this;
      self.orderImportDoing = true;
      AliexpressStore.batchManualAckOrder(obj).then(function (res) {
        self.orderImportDoing = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.platformImportSuccess"),
            type: "success",
          });
        } else {
          self.sysError();
        }
      });
    },
    importEbay(obj) {
      const self = this;
      self.orderImportDoing = true;
      EbayStore.batchManualAckOrder(obj).then(function (res) {
        self.orderImportDoing = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.platformImportSuccess"),
            type: "success",
          });
        } else {
          self.sysError();
        }
      });
    },
    importAmazon(obj) {
      const self = this;
      self.orderImportDoing = true;
      AmazonStore.batchManualAckOrder(obj).then(function (res) {
        self.orderImportDoing = false;
        if (res.status === 200) {
          if (res.data.statusCode == "500") {
            self.$message({
              message: res.data.message,
              type: "warning",
            });
            self.amazonSubmitDF = true;
            self.currentLastTime = 180;
            let wait = 180;
            const interval = window.setInterval(function () {
              self.currentLastTime = wait--;
              if (wait < 1) {
                self.amazonSubmitDF = false;
                window.clearInterval(interval);
              }
            }, 1000);
            self.currentLastTime = wait--;
          } else {
            self.$message({
              message: self.$t("prompt.platformImportSuccess"),
              type: "success",
            });
          }
        } else {
          self.sysError();
        }
      });
    },
    importShopify(obj) {
      const self = this;
      self.orderImportDoing = true;
      ShopifyStore.batchManualAckOrder(obj).then(function (res) {
        self.orderImportDoing = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.platformImportSuccess"),
            type: "success",
          });
        } else {
          self.sysError();
        }
      });
    },
    importTaobao(obj) {
      const self = this;
      self.orderImportDoing = true;
      TaobaoStore.batchManualAckOrder(obj).then(function (res) {
        self.orderImportDoing = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.platformImportSuccess"),
            type: "success",
          });
        } else {
          self.sysError();
        }
      });
    },
  },
};
</script>
<style lang="scss">
.adapterImport form .el-form-item {
  margin-bottom: 6px;
}
</style>